import React from 'react';
import { useMonth } from '@datepicker-react/hooks';
import { useGlobal } from '@rcg/ui-react';
import Day from '../Day';
import useStyles from './index.style';

function Month({ year, month, firstDayOfWeek, monthRef, singleDaySelection = false }) {
  const classes = useStyles();
  const {
    data: { localizedDayjs, lang },
  } = useGlobal();

  const { days, monthLabel } = useMonth({
    year,
    month,
    firstDayOfWeek,
    monthLabelFormat: (date) => localizedDayjs(date).format('MMMM'),
    dayLabelFormat: (date) => localizedDayjs(date).format('D'),
  });

  function getLocalizedWeekDays(locale) {
    localizedDayjs.locale(locale);
    const startOfWeek = localizedDayjs().startOf('week');
    const weekDays = [];

    for (let i = 0; i < 7; i += 1) {
      weekDays.push(startOfWeek.add(i, 'day').format('dddd'));
    }
    return weekDays;
  }

  const daysLocale = getLocalizedWeekDays(lang || 'en');

  return (
    <div ref={monthRef} className={classes.monthWrapper}>
      <div className={classes.monthLabel}>
        {monthLabel} {year}
      </div>
      <div className={classes.monthWeekdayLabels}>
        {daysLocale.map((dayLabel) => (
          <div className={classes.monthDaysLabel} key={dayLabel}>
            {dayLabel.charAt(0).toUpperCase()}
          </div>
        ))}
      </div>
      <div className={classes.monthDays}>
        {days.map((day, index) => {
          if (typeof day === 'object') {
            return (
              <Day
                key={day.date.toString()}
                day={day.dayLabel}
                date={day.date}
                singleDaySelection={singleDaySelection}
              />
            );
          }
          // eslint-disable-next-line react/no-array-index-key
          return <div key={index} />;
        })}
      </div>
    </div>
  );
}

export default Month;
